<template>
  <transition name="fade">

    <div class="home-page">
      <div class="section-container" id="home-fullpage">
        <section class="market-screen home-slider section" id="marketScreen" v-view="showPitfall">
          <div class="flex-container">
            <div class="col">
              <div class="text-container fade-in" v-view>
                <div class="headline-1">
                 <b>绿展国际科创产业
                 <br />投资孵化平台</b>
                </div>
                <div class="headline-1">
                <p></p>
                </div>
                <div class="description">
                  <p>绿展集团（Green Prosperity Group）是一家从事国际高科技引进的产业投资孵化平台，甄选全球优质科创及文创成果，全面服务中国。
                  </p>
                </div>
              </div>
            </div>
             <div class="col">
              <div class="circle-1 lightgreen-gradient-bg">
                <div class="circle-video">
                   <div class="circle-logo">
                    <img src="../assets/logo-vertical.png" alt="绿展集团">
                  </div>
                  <video muted loop="loop" autoplay="autoplay" >
                    <source src="../assets/video.mp4" type="video/mp4">
                  </video>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section class="landing-screen market-screen home-slider section" id="landingScreen" v-view="hidePitfall">
          <div class="flex-container">
            <div class="col">
              <div class="text-container fade-in" v-view>
                <div class="headline-1">
                  <b>发展历程</b>
                </div>
                 <div class="headline-3"><b>2023年</b></div>
                <div class="description">
                  <br/>1 2 月 集团所属江西省昌盛投资发展有限公司建设的南昌市昌盛梅岭森林康养基地，被中国森林康养基地遴选赋能活动组织委员会初选认定为“国家机关老干部疗休养基地”。并被确定为样板基地，将为“国家森林康养基地”新一轮高质量发展贡献更大的力量；
                  <br/>1 2 月 绿展科技入选2023年广东省省级专精特新中小企业；
                 <br/>1 1 月 集团注册成立“国林草管理（深圳）有限公司”，将参与“国家森林康养基地”的赋能工作，将获授权进行基地托管管理、基地从业人员培训考试及证书颁发、基地的全系列物料供应服务、基地的特色医养功能的技术输出服务；
                 <br/>1 1 月  绿展科技入选粤港澳大湾区“高成长企业”俱乐部；
                 <br/>08 月 绿展科技获第二届“太湖之芯”创业大赛优秀奖；
                 <br/>08 月 集团公司入股并主导运营中清国华（山东）生态科技有限公司；
                </div>
              </div>
            </div>
           <div class="col">
                <div class="right-pic"><img src="../assets/zhengshu.png"></div>
            </div>
            </div>
        </section>
        <section class="landing-screen market-screen home-slider section" id="landingScreen" v-view="hidePitfall">
          <div class="flex-container">
            <div class="col">
              <div class="text-container fade-in" v-view>
                <div class="headline-1">
                  <b>发展历程</b>
                </div>
                 <div class="headline-3"><b>2023年</b></div>
                <div class="description">
                 <br/>07 月 绿展科技玻璃基指纹传感器获第七届“葵花奖”技术种子奖；
                 <br/>04 月 绿展控股（深圳）有限公司被授予“清华大学老科学技术工作者协会专家工作站”;
                 <br/>04 月 我公司董事长蓝海被清华大学两岸发展研究院聘请为“两岸企业家联盟理事”;
                 <br/>02 月 绿展科技创始人兼 CEO 蓝梓淇凭借“微米级集成电路的增材制造方案”荣膺2022年“科创中国”青年创业榜单-深圳U30;
                 <br/>02 月 绿展科技完成数千万元A轮融资,本轮融资由国中资本领投,佛山市南海产投、佛山市桂城科技股权、海杨创投之丹阳深海投资基金跟投。
                 <br/>01 月 集团聘请杨少稀同志为绿展集团高级顾问，杨少稀同志是中国船舶武船集团原党委副书记，董事副总经理、监事会主席、工会主席、中共党员、大学学历、高级工程师、一级建造师、湖北省第十一届及第十二届人大代表、湖北省优秀企业家。
                </div>
              </div>
            </div>
           <div class="col">
                <div class="right-pic"><img src="../assets/2023.png"></div>
            </div>
            </div>
        </section>
        <section class="landing-screen market-screen home-slider section" id="landingScreen" v-view="hidePitfall">
          <div class="flex-container">
            <div class="col">
              <div class="text-container fade-in" v-view>
                <div class="headline-1">
                  <b>发展历程</b>
                </div>
                 <div class="headline-3"><b>2022年</b></div>
                <div class="description">
                 <br/>12月 绿展科技获广东省2022年第一批“国家高新技术企业“认定;
                 <br/>12月 绿展科技获得第十一届中国创新创业大赛广东赛区二等奖;
                 <br/>11月 绿展科技与美的厨房和热水事业部宣布达成战略合作;
                 <br/>11月 绿展科技宣布与全球汽车座椅供应商重庆安道拓汽车部件系统有限公司达成深度合作;
                 <br/>09月 绿展科技入围第十一届中国创新创业大赛全国赛成长组;
                 <br/>07月 绿展科技荣获大湾区高成长企业TOP50;
                 <br/>06月 绿展科技荣获“榜样力量”桂城首批优秀创业团队、成为璞跃中国创新加速营成员;
                 <br/>03月 绿展科技第二期无尘车间投产;
                 <br/>02月 绿展科技、中科院苏州纳米所、广东中科半导体微纳制造研究院成立“纳展微电子精密印刷制造联合实验室”。
                </div>
              </div>
            </div>
           <div class="col">
                <div class="right-pic"><img src="../assets/2022.png"></div>
            </div>
            </div>
        </section>
        <section class="landing-screen market-screen home-slider section" id="landingScreen" v-view="hidePitfall">
          <div class="flex-container">
            <div class="col">
              <div class="text-container fade-in" v-view>
                <div class="headline-1">
                  <b>发展历程</b>
                </div>
                 <div class="headline-3"><b>2021年</b></div>
                <div class="description">
                 <br/>11月  绿展科技获得由深创投领投和力合科创参与的数千万pre-A轮融资,用于加大研发和人才团队的投入、扩大产能、进一步开拓国内精密印刷应用市场;
                 <br/>09月  中国科学院苏州纳米与纳米仿生研究所党委书记、副所长（主持工作）邓强一行领导莅临绿展科技指导。
                </div>
              </div>
            </div>
           <div class="col">
                <div class="right-pic"><img src="../assets/2020.jpg"></div>
            </div>
            </div>
        </section>
        <section class="landing-screen market-screen home-slider section" id="landingScreen" v-view="hidePitfall">
          <div class="flex-container">
            <div class="col">
              <div class="text-container fade-in" v-view>
                <div class="headline-1">
                  <b>发展历程</b>
                </div>
                 <div class="headline-3"><b>2020年</b></div>
                <div class="description">
                  12月 绿展获批成立中国科协海智计划广东（深圳）基地。
                 <br/>08月 绿展科技佛山无尘车间正式投产。
                 <br/>08月 绿展科技与中科院苏州纳米所广东(佛山)研究院正式签署合资协议。
                 <br/>06月 广东绿展科技公司高精度印刷电子喷墨产线在佛山南海动工。
                 <br/>05月 与中科院苏州纳米所广东(佛山)研究院签署战略合作协议。
                 <br/>05月 广东绿展科技有限公司正式成立。
                </div>
              </div>
            </div>
           <div class="col">
                <div class="right-pic"><img src="../assets/2019.jpg"></div>
            </div>
            </div>
        </section>
        <section class="landing-screen market-screen home-slider section" id="landingScreen" v-view="hidePitfall">
          <div class="flex-container">
            <div class="col">
              <div class="text-container fade-in" v-view>
                <div class="headline-1">
                  <b>发展历程</b>
                </div>
                 <div class="headline-3"><b>2019年</b></div>
                <div class="description">
                  12月 绿展集团获人民日报报道。
                 <br/>12月 绿展集团获深圳卫视《深视新闻》澳门回归二十载专题报道。
                 <br/>12月 绿展江西省昌盛投资发展有限公司成立，并与中国电子成立工业互联网工作小组。
                 <br/>11月 绿展集团与中国普天签订战略合作协议，共建国际化信息产业中心。
                 <br/>07月 绿展集团获CCTV-2央视财经频道《经济信息联播》报道。
                 <br/>05月 澳门经济局副局长刘伟明、厅长邱润华率澳门青创交流团到访绿展。
                 <br/>05月 绿展集团联合佛山中科院产业技术研究院举办国际科创产业对接会。
                 <br/>04月 绿展集团在硅谷举办首场国际投资人酒会。
                 <br/>01月 绿展控股（深圳）有限公司斩获“第五届高新杯十大最具投资潜力奖”。
                </div>
              </div>
            </div>
           <div class="col">
              <div class="right-pic"><img src="../assets/2019.png"></div>
            </div>
            </div>
        </section>
        <section class="landing-screen market-screen home-slider section" id="landingScreen" v-view="hidePitfall">
          <div class="flex-container">
            <div class="col">
               <div class="headline-1"><b>发展历程</b></div>
              <div class="text-container fade-in" v-view>
                <div class="headline-3"><b>2018年</b></div>
                <div class="description">
                   12月 绿展集团承办2018世界青年创业论坛，并与前海科创投签署合作协议。
                   <br/>11月 金迈元小分子蛋白肽参展首届中国国际进口博览会。
                   <br/>11月 绿展控股（深圳）有限公司注册成立，入驻前海。
                   <br/>9月 珠海横琴新区商务局、横琴绿展科技有限公司、美国五大机构签订战略合作协议。
                </div>
              </div>
              <div class="text-container fade-in" v-view>
                  <div class="headline-3"><b>2017年</b></div>
                <div class="description">
                   12月 绿展集团在中国澳门注册成立。
                </div>
          </div>
          </div>
           <div class="col">
               <div class="right-pic"><img src="../assets/2018.jpg"></div>
            </div>
            </div>
        </section>
        <GPFooter />
      </div>
   </div>
  </transition>
</template>

<style lang="scss" src="./HomePage.scss">
</style>

<script>
import Fullpage from 'fullpage.js'
export default {
  name: 'HomePage',
  props: {},
  data () {
    return {
      homeSliders: null,
      isPitfallHide: true
    }
  },
  methods: {
    formatter (num) {
      return num.toFixed(1)
    },
    animStart (e, n) {
      this.$refs[`teamNum_${n}`].start()
    },
    hidePitfall () {
      this.isPitfallHide = true
    },
    showPitfall () {
      this.isPitfallHide = false
    },
    resizeEvent (e) {
      e.stopPropagation()
      if (document.body.offsetWidth > 1024 && this.homeSliders === null) {
        this.initFullPage()
      }
    },
    initFullPage () {
      this.homeSliders = new Fullpage('#home-fullpage', {
        licenseKey: 'FAE6D29E-C9664B70-A1915489-3CEF9EF7',
        autoScrolling: true,
        lazyLoading: true,
        easingcss3: 'cubic-bezier(0.75, 0, 0.25, 1)',
        fitToSectionDelay: 180,
        fadingEffect: false,
        animateAnchor: false,
        scrollingSpeed: 800,
        scrollBar: true,
        navigation: true,
        navigationPosition: 'left',
        afterResize: (width, height) => {
          if (width < 1024) {
            this.homeSliders.destroy('all')
            this.homeSliders = null
          }
        }
      })
    }
  },
  created () {
  },
  destroyed () {
    if (this.homeSliders !== null) {
      this.homeSliders.destroy('all')
      this.homeSliders = null
    }
    window.removeEventListener('resize', this.resizeEvent)
  },
  mounted () {
    window.addEventListener('resize', this.resizeEvent)
    if (document.body.offsetWidth > 1024 && this.homeSliders === null) {
      this.initFullPage()
    }
  },
  watch: {
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/HomePage.vue